import axios from 'axios'

export default {
  getLogoProviderConfirmation: async ({commit, getters}, data) => {
    const { data: response } = await axios.get(process.url + 'Hotsite/GetLogo?Type=' + data.type, { headers: { 'Token': data.token } })
    commit('loadLogoProviderConfirmation', response.resultado)
  },
  async getScheduleDetails ({commit, rootGetters, state}, payload) {
    await axios({
      method: 'get',
      url: process.url + 'Hotsite/DetalhesAgendamento',
      timeout: 200000,
      headers: {
        'Token': payload
      }
    })
    .then((response) => {
      commit('setScheduleDetails', response.data.resultado)
    })
    .catch((error) => {
      console.log(error)
    })
  },
  async getAllInfoConfirmation ({commit, dispatch}, data) {
    commit('toggleLoadingConfirmation', true)
    try {
      await dispatch('getLogoProviderConfirmation', data)
    } catch (e) {
      commit('toastrAxiosError', e)
      commit('toggleLoadingConfirmation', false)
    }
    commit('toggleLoadingConfirmation', false)
  },
  sendEmailToCondominiums ({commit, dispatch}, payload) {
    const url = 'Agendamento/AnswerByPosition?tipo=' + payload.type + '&tkn=' + payload.token + '&answer=' + payload.send + '&t=2'
    axios({
      method: 'get',
      url: process.url + url,
      timeout: 200000,
      headers: {
        'Token': payload.token
      }
    })
    .then((response) => {
    })
    .catch((error) => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/hotsite/confirmacao/actions.js